module.exports = __webpack_public_path__ + "img/038.2aaeebcf.png";